export default "__VITE_ASSET__CDBDHbkQ__"